export default "__VITE_ASSET__04z21IB4__"